export default {
    state: {
        list: null,
        count: null,

        filters: {
            answer : '',
            advertisingId: null,
            order: 'nome',
            desc: true,
            devices: null,
            'data.min': null,
            'data.max': null
        },
    },

    mutations: {
        ANSWERADVERTISING_SET_LIST(state, list) {
            state.list = list
        },

        ANSWERADVERTISING_SET_COUNT(state, count) {
            state.count = count
        },

        ANSWERADVERTISING_SET_FILTER(state, {key, value}) {
            state.filters = {
                ...state.filters,
                [key]: value,
            }
        },

        ANSWERADVERTISING_RESET_FILTERS(state){
            state.filters = {
                answer : '',
                advertisingId: null,
                order: 'nome',
                desc: true,
                devices: null,
                'data.min': null,
                'data.max': null
            }
        }


    },
}
